import device from './device';

const list = () => {
  const listElem = document.querySelector('.c-team');

  if (listElem) {
    const listItems = document.querySelectorAll('.c-tease--team');
    if (listItems.length) {
      if (device.touch() || !device.desktop()) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < listItems.length; i++) {
          const title = listItems[i].querySelector('.c-tease__title');

          title.addEventListener('click', () => {
            listItems[i].classList.toggle('c-tease--active');
          });
        }
      }
    }
  }
};

export default { list };



// WEBPACK FOOTER //
// ./public/wp-content/themes/druckhaus/src/scripts/modules/team.js